export default {
  // eslint-disable-next-line
  email: /^\w+((-\w+)|(\.\w+)|(\+[\w\d]+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/,
  password: /^(?!.*[^a-zA-Z0-9])(?=.*\d)(?=.*[a-zA-Z]).{8,64}$/,
  carrier_id: /^\/[0-9A-Z+-.]{7}/,
  order_number: /^\d{0,64}$/,
};



// WEBPACK FOOTER //
// ../pos-master/packages/pos-helper/src/pattern.js